export default __webpack_public_path__ + "static/t3-cab859e62d35c0d70e79fc18d9580e44.webp";